import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { find, orderBy } from 'lodash';
import EventBus from '@vertical-plus/vue-js-core/dist/util/event/event-bus';
import Job from '@/model/entity/job/job';
import draggable from 'vuedraggable';

@Component({
    components:
    {
        draggable,
    },
})
export default class JobTasks extends Vue
{
    @Prop()
    private milestone!: Job;

    @Prop()
    private tasks!: Job[];

    @Prop({
        type: Boolean,
        default: false,
    })
    private project!: boolean;

    private localTasks: Job[] = [];

    private _orderedTasks: Job[] = [];
    private _orderedTasksDirty = true;

    private created()
    {
        this.onTaskUpdated();
    }

    @Watch('tasks')
    private onTaskUpdated()
    {
        this.localTasks = this.tasks;
    }

    /**
     * Returns the tasks ordered properly based on the techspec type
     */

    private get orderedTasks(): Job[]
    {
        // If the array is dirty, regenerate it
        if (typeof (this._orderedTasksDirty) === 'undefined' || this._orderedTasksDirty === true)
        {
            this._orderedTasksDirty = false;

            // If a project, order the jobs by their defined order
            if (this.project)
            {
                this._orderedTasks = orderBy(this.localTasks, [ 'order', 'created' ]);
            }

            // Otherwise return as they have been set from the server
            else
            {
                this._orderedTasks = this.localTasks;
            }
        }

        return this._orderedTasks;
    }

    /**
     * Updates the ordering of tasks
     */

    private set orderedTasks(tasks: Job[])
    {
        if (!this.milestone.id)
        {
            return;
        }

        // Update the actual task's order
        const orders: {[key: number]: number} = {};
        let order = 1;

        for (const task of tasks)
        {
            if (!task.id)
            {
                continue;
            }

            const actualTask = find(this.localTasks, { id: task.id });
            if (!actualTask)
            {
                continue;
            }

            actualTask.order = order;

            orders[task.id] = order;

            order++;
        }

        // Update the server
        this.$serviceContainer.jobService.updateChildJobOrder(this.milestone.id, orders);

        // Mark the ordered tasks as being dirty
        this._orderedTasksDirty = true;
    }

    /**
     * Handles previewing a job
     *
     * @param job
     */

    private onPreviewJob(job: Job)
    {
        EventBus.instance.$emit('preview-job', job.id);
    }
}